import { digitsEnToFa } from "persian-tools2";
import moment from "moment";

const yearsArray = () => {
  let years = [];
  const thisYear =moment().locale('fa').format('YYYY')
  for (let i = 1300; i <= thisYear; i++) {
    years.push(i);
  }
  return years;
};

const monthsArray = [
  { value: 'فروردین' },
  { value: 'اردیبهشت' },
  { value: 'خرداد' },
  { value: 'تیر' },
  { value: 'مرداد' },
  { value: 'شهریور' },
  { value: 'مهر' },
  { value: 'آبان' },
  { value: 'آذر' },
  { value: 'دی' },
  { value: 'بهمن' },
  { value: 'اسفند' },
];
const pregnancyItems = [
  { value: false, label: 'باردار نیست' },
  { value: true, label: 'باردار است' },
];

const dayArray = (endDy) => {
  let days = [];
  for (let i = 1; i <= endDy; i++) {
    days.push(i);
  }
  return days;
};


const formatedString = (arg) => (arg < 10 ? `0${arg}` : arg);

const diabetYearsArray = () => {
  const years = [];
  for (let i = 0; i < 100; i++) {
    years.push({ value: i === 0 ? (`زیر یک سال`) : (`${i} سال`) });
  }
  return years;
};

const insulinItems = [
  { value: 0, label: 'خیر' },
  { value: 1, label: digitsEnToFa('2 مرتبه در روز یا کمتر') },
  { value: 2, label: digitsEnToFa('3 مرتبه در روز یا بیشتر') },
];

const genderItems = [
  { value: false, label: 'زن' },
  { value: true, label: 'مرد' },
];

const diabetItems = [
  { value: 0, label: 'دیابت نوع یک' },
  { value: 1, label: 'دیابت نوع دو' },
  { value: 2, label: 'دیابت بارداری' },
  { value: 3, label: 'نامشخص' },
  { value: 4, label: 'پیش دیابت' },
];

const oralMedicationItems = [
  { value: false, label: 'خیر' },
  { value: true, label: 'بله' },
];


export { monthsArray,pregnancyItems, dayArray, yearsArray, formatedString, diabetYearsArray, insulinItems, genderItems, diabetItems, oralMedicationItems };